import { useState } from 'react';
import { Modal } from 'animal-island-ui';
import { GOD_AVATARS, GOD_IMAGES } from '../godImages';
import { GODS } from '../data/mockData';
import { useAppStore } from '../store/useAppStore';
import type { GodName } from '../types';

interface GodAvatarProps {
  god: GodName;
  size?: number;
  onClick?: () => void;
  className?: string;
}

// 神仙头像组件，点击展示完整形象图
export default function GodAvatar({ god, size = 36, onClick, className }: GodAvatarProps) {
  const [showFull, setShowFull] = useState(false);
  const avatarSrc = GOD_AVATARS[god];
  const fullSrc = GOD_IMAGES[god];
  // 优先用 store 中由 API 覆盖过的神仙信息（desc 为 domainDesc），fallback 到静态 GODS
  const godInfo = useAppStore((s) => s.gods[god]) || GODS[god];

  return (
    <>
      <img
        src={avatarSrc}
        alt={godInfo.name}
        className={`rounded-full border-2 object-cover cursor-pointer hover:scale-110 transition-transform ${className || ''}`}
        style={{
          width: size,
          height: size,
          borderColor: godInfo.color,
        }}
        onClick={(e) => {
          e.stopPropagation();
          if (onClick) onClick();
          else setShowFull(true);
        }}
      />

      <Modal
        open={showFull}
        onClose={() => setShowFull(false)}
        title={`${godInfo.emoji} ${godInfo.name} - ${godInfo.title}`}
        footer={null}
        width={400}
      >
        <div className="flex flex-col items-center py-4">
          <img
            src={fullSrc}
            alt={godInfo.name}
            className="w-64 h-64 object-contain rounded-xl"
            style={{ filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.15))' }}
          />
          <p className="mt-4 text-sm text-gray-500 text-center">{godInfo.desc}</p>
        </div>
      </Modal>
    </>
  );
}
